<template>
  <div :class="['flex-row box', {new: isUnread}]" @click="$emit('read:notification')">
    <div class="noti_img">
      <BaseImage :src="item.imageSrc" :alt="item.imageAlt" />
    </div>

    <div class="flex-column">
      <div class="flex-row top_row">
        <p class="date_time">{{ date }}</p>

        <p v-if="isUnread" class="new">
          {{ $_translations.value.page_notification_item_common_new }}
        </p>
      </div>

      <div class="flex-column noti_content">
        <h3>{{ $_translations.value[item.title] }}</h3>

        <p>
          <template v-for="(description, index) in item.descriptionAsList" :key="index">
            <template
              v-if="description.type === notificationDescriptionTextTypeEnum.TRANSLATION_KEY"
            >
              {{ $_translations.value[description.value] }} {{ ' ' }}
            </template>

            <template
              v-else-if="description.type === notificationDescriptionTextTypeEnum.STYLED_TRANSLATION_KEY"
            >
              <span>{{ $_translations.value[description.value] }} {{ ' ' }}</span>
            </template>

            <template
              v-else-if="description.type === notificationDescriptionTextTypeEnum.DYNAMIC_VALUE"
            >
              <span>{{ description.value }}{{ ' ' }}</span>
            </template>
          </template>
        </p>
      </div>
    </div>

    <i class="fas fa-chevron-right"></i>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import moment from 'moment';
import BaseImage from '@/components/image/BaseImage.vue';
import { notificationDescriptionTextTypeEnum } from '@/constants/notification.js';

defineEmits(['read:notification']);

const props = defineProps({
  item: {
    type: Object,
    default: () => ({}),
  },
});

const isUnread = computed(() => props.item.isUnread);

const date = computed(() => moment(props.item.date).format('DD/MM/YYYY, HH:mm:ss'));
</script>
